import React from "react";
import { useNavigate } from "react-router-dom";
import { FaTimesCircle } from "react-icons/fa";

const Cancel = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        textAlign: "center",
        padding: "80px 20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <FaTimesCircle size={80} color="#e74c3c" />
      <h1 style={{ marginTop: "20px", color: "#333" }}>
        Pago cancelado o fallido
      </h1>
      <p style={{ color: "#555", fontSize: "18px", marginTop: "10px" }}>
        No se ha procesado ningún cobro. Puedes intentarlo nuevamente.
      </p>
      <button
        onClick={() => navigate("/")}
        style={{
          marginTop: "30px",
          backgroundColor: "#4B6CB7",
          color: "white",
          border: "none",
          borderRadius: "25px",
          padding: "12px 30px",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        Volver a la tienda
      </button>
    </div>
  );
};

export default Cancel;
